import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import {
  Row,
  Form,
  Menu,
  Affix,
  Button,
  Space,
  Drawer,
  Card,
  Input,
  Divider,
  Avatar,
  Select
} from "antd";
import {
  PoweroffOutlined,
  UserOutlined,
  MenuOutlined,
  FileSearchOutlined,
  FileAddOutlined,
  FileProtectOutlined,
  SettingOutlined,
  CloseOutlined,
  SaveOutlined,
  TeamOutlined,
  FileTextOutlined,
  InteractionOutlined,
  BankOutlined,
  PieChartOutlined,
  FundOutlined,
  PlusSquareOutlined,
  ReadOutlined,
  SolutionOutlined
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";

import "./index.css";

const { Option } = Select;

const layout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 }
};

const Header_title = props => {
  const [form1] = Form.useForm();

  let xURL = "";
  let xlocation = window.location.hostname;

  // if (xlocation === "localhost") {
  //   xURL = "http://localhost:3002/api/";
  // } else {
  xURL = "https://research.rihes.cmu.ac.th/api/";
  // }

  const [visible, _Visible] = useState(false);
  const [visible2, _Visible2] = useState(false);

  const [xtitle_name, _xtitle_name] = useState("");
  const [xfirst_name_th, _xfirst_name_th] = useState("");
  const [xlast_name_th, _xlast_name_th] = useState("");
  const [xfirst_name_eng, _xfirst_name_eng] = useState("");
  const [xlast_name_eng, _xlast_name_eng] = useState("");
  const [xposition, _xposition] = useState("");
  const [xcenter, _xcenter] = useState("");
  const [xemail, _xemail] = useState("");

  //const toggleButton = document.getElementsByClassName("toggle-button")[0];
  const navbarLinks = document.getElementsByClassName("navbar-links")[0];

  const [levelU, _levelU] = useState("");
  const [research_ShowD, _research_ShowD] = useState("");

  let logoutUrl = ``;
  if (xlocation === "localhost") {
    logoutUrl = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(
      "http://localhost:3000/login"
    )}`;
  } else {
    logoutUrl = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(
      "https://research.rihes.cmu.ac.th/login"
    )}`;
  }

  useEffect(() => {
    axios
      .post(xURL + "findlevel", {
        research_name: props.tname
          ? props.tname.firstname_TH + " " + props.tname.lastname_TH
          : ""
      })
      .then(result => {
        // console.log(result.data.length);
        if (result.data.length > 0) {
          if (result.data[0].user_level_id == 2) {
            _levelU("user");
          } else if (result.data[0].user_level_id == 3) {
            _levelU("financial");
          } else if (result.data[0].user_level_id == 4) {
            _levelU("research");
            _research_ShowD(result.data[0].researcher_staff_id);
          } else if (result.data[0].user_level_id == 5) {
            _levelU("manager");
          } else if (result.data[0].user_level_id == 7) {
            _levelU("student");
          } else if (result.data[0].user_level_id == 6) {
            _levelU("admin");
          } else if (result.data[0].user_level_id == 8) {
            _levelU("coordiantor");
          } else if (result.data[0].user_level_id == 99) {
            _levelU("SuperAdmin");
          } else {
            _levelU("guest");
          }

          // console.log(result.data[0].researcher_staff_id);
        } else {
          _levelU("guest");
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  }, []);

  const toggleClick = () => {
    navbarLinks.classList.toggle("active");
  };

  const onLogout = () => {
    localStorage.clear();
    window.location.href = logoutUrl;
  };

  const showDrawer = () => {
    _Visible(true);
  };

  const showDrawer2 = () => {
    _xtitle_name(props.tname ? props.tname.prename_TH : "");
    _xfirst_name_th(props.tname ? props.tname.firstname_TH : "");
    _xlast_name_th(props.tname ? props.tname.lastname_TH : "");
    _xfirst_name_eng(props.tname ? props.tname.firstname_EN : "");
    _xlast_name_eng(props.tname ? props.tname.lastname_EN : "");
    _xcenter(props.tname ? props.tname.organization_name_TH : "");
    _xposition(props.tname ? props.tname.itaccounttype_TH : "");
    _xemail(props.tname ? props.tname.cmuitaccount : "");

    _Visible2(true);
  };

  const onClose = () => {
    window.location.reload();
    _Visible(false);
  };

  const onClose2 = () => {
    _Visible2(false);
  };

  return (
    <Affix offsetTop={0} className="app__affix-header">
      <div>
        <nav className="navbar">
          <div
            className="brand-title"
            onClick={() => {
              if (levelU == "student") {
                window.location = "/Research_main";
              } else if (levelU == "guest") {
                window.location = "/Research_guest";
              } else {
                window.location = "/Research_scopus";
              }
            }}
          >
            <Space>
              <img width={45} src="./RIHES_Logo-White.png" />

              <a
                style={{
                  fontWeight: "bold",
                  color: "white"
                }}
              >
                ระบบบริหารงานวิจัย
              </a>
            </Space>
          </div>

          <a href="#" class="toggle-button" onClick={toggleClick}>
            <span class="bar" />
            <span class="bar" />
            <span class="bar" />
          </a>

          {/* 23 รองลินดา 20 รองสุรัตน์ */}
          <div className="navbar-links">
            <ul>
              {(levelU == "research" || levelU == "student") &&
              (research_ShowD !== 20 && research_ShowD !== 23)
                ? <li />
                : <li className="dropdown">
                    <a className="dropbtn">
                      <PieChartOutlined /> Dashboard
                    </a>
                    <div class="dropdown-content">
                      {levelU == "guest"
                        ? <div />
                        : <a href="/Research_dashboard" target="_blank">
                            <PieChartOutlined /> Dashboard1
                          </a>}
                      <a href="/OKRs_Dashboard" target="_blank">
                        <PieChartOutlined /> Dashboard2
                      </a>
                      {levelU == "guest"
                        ? <div />
                        : <a href="/Dashboard3" target="_blank">
                            <PieChartOutlined /> Dashboard3
                          </a>}
                      {levelU == "guest"
                        ? <div />
                        : <a href="/Dashboard4" target="_blank">
                            <PieChartOutlined /> Dashboard4
                          </a>}
                    </div>
                  </li>}

              {levelU == "student" || levelU == "guest"
                ? <li />
                : <li>
                    <a href="/Research_scopus">
                      <FileProtectOutlined /> SCOPUS
                    </a>
                  </li>}

              {levelU == "guest"
                ? <li />
                : <li className="dropdown">
                    <a className="dropbtn">
                      <SolutionOutlined /> โครงการวิจัย
                    </a>
                    <div class="dropdown-content">
                      <a href="/Research_main">
                        <FileSearchOutlined /> ค้นหาโครงการวิจัย
                      </a>
                      <a href="/Research_main_participant">
                        <FileSearchOutlined /> ค้นหาโครงการ(ผู้ร่วมวิจัย)
                      </a>

                      {levelU == "research" || levelU == "guest"
                        ? <a href="#" disabled>
                            <FileAddOutlined /> เพิ่ม โครงการวิจัย
                          </a>
                        : <a href="/Research_input">
                            <FileAddOutlined /> เพิ่ม โครงการวิจัย
                          </a>}

                      {levelU == "admin" ||
                      levelU == "SuperAdmin" ||
                      levelU == "financial"
                        ? <a href="/Research_coordinator">
                            <FileAddOutlined /> รายการขออนุมัติใช้เงิน
                          </a>
                        : <div />}
                    </div>
                  </li>}

              {levelU == "research" || levelU == "student" || levelU == "guest"
                ? <li />
                : <li>
                    <a href="/Research_staff">
                      <TeamOutlined /> นักวิจัย / บุคลากร
                    </a>
                  </li>}

              {levelU == "guest"
                ? <li />
                : <li>
                    <a href="/Research_academic">
                      <BankOutlined /> สำนักวิชาฯ
                    </a>
                  </li>}

              {levelU == "guest"
                ? <li />
                : <li className="dropdown">
                    <a className="dropbtn">
                      <ReadOutlined /> ทรัพย์สินทางปัญญา
                    </a>
                    <div class="dropdown-content">
                      {levelU == "research" ||
                      levelU == "student" ||
                      levelU == "guest"
                        ? <a href="#" disabled>
                            <PlusSquareOutlined /> เพิ่ม/แก้ไข ทรัพย์สินทางปัญญา
                          </a>
                        : <a href="/Research_input_patent">
                            <PlusSquareOutlined /> เพิ่ม/แก้ไข ทรัพย์สินทางปัญญา
                          </a>}
                      <a href="/Research_report_patent">
                        <FileTextOutlined /> รายงานทรัพย์สินทางปัญญา
                      </a>
                    </div>
                  </li>}

              {levelU == "guest"
                ? <li />
                : <li className="dropdown">
                    <a href="/Research_pms">
                      <FundOutlined /> PMS
                    </a>
                  </li>}

              {levelU == "student" || levelU == "guest"
                ? <li />
                : <li className="dropdown">
                    <a className="dropbtn">
                      <FileTextOutlined /> รายงาน
                    </a>
                    <div class="dropdown-content">
                      <a href="/Research_report">
                        <FileTextOutlined /> รายงานเงินรับเข้าโครงการวิจัย
                      </a>
                      <a href="/Research_report_received1">
                        <FileTextOutlined /> รายงานเงินทุนโครงการวิจัยที่ได้รับ
                        ตามปีปฏิทิน (1ม.ค.-31ธ.ค.)
                      </a>
                      <a href="/Research_report_received2">
                        <FileTextOutlined /> รายงานเงินทุนโครงการวิจัยที่ได้รับ
                        ตามปีงบประมาณ (1ต.ค.-30ก.ย.)
                      </a>
                      <a href="/Research_report1_2">
                        <FileTextOutlined /> รายงานเงินงวดค้างรับ
                      </a>
                      <a href="/Research_report_to_cmu">
                        <FileTextOutlined /> รายงานการส่งเงินสมทบ
                      </a>
                      <a href="/Research_report1_1">
                        <FileTextOutlined />{" "}
                        รายงานเงินรับเข้าโครงการวิจัยรายโครงการ
                      </a>
                      <a href="/Research_report2">
                        <FileTextOutlined /> รายงานแสดงแหล่งทุน
                      </a>

                      <a href="/Research_report3">
                        <FileTextOutlined /> ผลลัพธ์ด้านผลิตภัณฑ์และกระบวนการ
                      </a>
                      <a href="#" disabled>
                        <FileTextOutlined /> ผลลัพธ์ด้านการเงิน ตลาด และกลยุทธ์
                      </a>
                      <a href="/Research_pub_type_cmu">
                        <InteractionOutlined /> ทิศทางการวิจัยของโครงการวิจัย
                      </a>
                    </div>
                  </li>}

              <li>
                <a onClick={showDrawer}>
                  สวัสดี {(props.tname && props.tname.firstname_TH) || ""}{" "}
                  <MenuOutlined />
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <Drawer
          title={(props.tname && props.tname.firstname_TH) || ""}
          closable={false}
          onClose={onClose}
          visible={visible}
          width={250}
        >
          <Menu>
            <Menu.Item key="6" onClick={showDrawer2}>
              <UserOutlined /> ข้อมูลส่วนตัว
            </Menu.Item>

            <Menu.Item key="7" onClick={onLogout}>
              <PoweroffOutlined /> ออกจากระบบ
            </Menu.Item>
          </Menu>

          <Drawer
            title="ข้อมูลส่วนตัว"
            closable={false}
            onClose={onClose2}
            visible={visible2}
            width={window.innerWidth > 1200 ? 600 : "auto"}
            extra={
              <Button
                icon={<CloseOutlined />}
                onClick={() => {
                  _Visible2(false);
                }}
              />
            }
          >
            <Card>
              <Form form={form1} initialValues={{}} {...layout}>
                <Row justify="center">
                  <Avatar size={100} icon={<UserOutlined />} />
                </Row>

                <Divider />

                <Form.Item label="ชื่อนำ" name="edtitle_name">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "50%", color: "black" }}
                      value={xtitle_name}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="ชื่อ ภาษาไทย" name="edfirst_name_th">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xfirst_name_th}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="นามสกุล ภาษาไทย" name="edlast_name_th">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xlast_name_th}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="ชื่อ ภาษาอังกฤษ" name="edfirst_name_eng">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xfirst_name_eng}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="นามสกุล ภาษาอังกฤษ" name="edlast_name_eng">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xlast_name_eng}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="สังกัด/หน่วยงาน" name="edcenter">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xcenter}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="ประเภท" name="edposition">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xposition}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="E-mail" name="edemail">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xemail}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="User Level" name="edlevel">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={levelU}
                    />
                  </Row>
                </Form.Item>
              </Form>
            </Card>

            <br />
            {levelU == "SuperAdmin"
              ? <Row justify="center">
                  <Button
                    type="primary"
                    onClick={() => {
                      window.location = "/Reseach_admin_manage";
                    }}
                  >
                    แก้ไขสิทธิ์ User
                  </Button>
                </Row>
              : <div />}
          </Drawer>
        </Drawer>
      </div>
    </Affix>
  );
};
export default Header_title;
